import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { UsersService } from "src/app/services/users.service";
import { Router } from "@angular/router";
import { Company } from "src/app/models/services/company";
import { GlobalsService } from "src/app/services/globals.service";
import { BaseTenantRequiredPageComponent } from "src/app/components/core/base-tenant-required-page/base-tenant-required-page.component";
import {
  MenuAction,
  MenuDivider,
} from "src/app/components/core/eris-menu/eris-menu.component";
import { AudiencesListFilter } from "src/app/models/ui/audiencesListFilter";
import { TransfersListFilterDialogService } from "src/app/services/dialogs/transfers-list-filter-dialog.service";

@Component({
  selector: "app-transfers-list",
  templateUrl: "./transfers-list.component.html",
  styleUrls: ["./transfers-list.component.sass"],
})
export class TransfersListComponent
  extends BaseTenantRequiredPageComponent
  implements OnInit
{
  public heading: string = "Transfers list";
  public subheading: string = "";
  public icon: string = "pe-7s-radio icon-gradient bg-midnight-bloom";
  public headerMenuConfiguration: (MenuAction | MenuDivider)[] = [
    {
      iconClass: "fa fa-search",
      label: "Filter transfers",
      action: () => this.showFilterDialog(),
    },
  ];

  public filter: string;
  public allowedCompanies: Company[];

  constructor(
    public usersService: UsersService,
    private transfersListFilterDialogService: TransfersListFilterDialogService,
    globalsService: GlobalsService,
    private spinnerService: NgxSpinnerService,
    private router: Router
  ) {
    super(
      usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesList') || usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesTransfers'),
      globalsService, router
    );

    if (this.redirecting) return;

    // Add action columns just if proper right is present
    this.allowedCompanies = globalsService.getAllowedCompanies();
  }

  ngOnInit(): void {
    if (this.redirecting) return;
  }

  showFilterDialog = (): void => {
    // TODO - Create filter dialog including target platforms, ...
    var filter: AudiencesListFilter = {
      textSearch: this.filter,
      tagsSearch: [],
    };
    this.transfersListFilterDialogService.show(
      filter,
      () => {
        this.spinnerService.show();
        this.filter = filter.textSearch;

        let searchAction: MenuAction = this
          .headerMenuConfiguration[0] as MenuAction;
        searchAction.iconClass = this.isFilterApplied()
          ? "fa fa-filter"
          : "fa fa-search";
        searchAction.actionClass = this.isFilterApplied() ? "text-warning" : "";
      },
      () => {}
    );
  };

  isFilterApplied = (): boolean => {
    return !!this.filter;
  };
}
